import { Time } from '@/constants';

const { ONE_SECOND_IN_MS, THREE_MINUTES_IN_SECONDS } = Time;
const INITIAL_RETRY_IN_SECONDS = 1;
const INITIAL_RETRY_IN_MS = INITIAL_RETRY_IN_SECONDS * ONE_SECOND_IN_MS;
const DEFAULT_ATTEMPTS_BEFORE_EXPONENTIAL_BACKOFF = 20;
// This doubles the amount of time to retry after each failure, up to a maximum of 3 minutes.
const EXPONENTIAL_BACKOFF_FACTOR = 2;
const MAX_BACKOFF_IN_SECONDS = THREE_MINUTES_IN_SECONDS;
const MAX_BACKOFF_IN_MS = MAX_BACKOFF_IN_SECONDS * ONE_SECOND_IN_MS;

/**
 * Calculates the number of milliseconds to wait before retrying something.
 * The first few attempts are quick, then the amount of time to wait follows an exponential
 * backoff, until it reaches a maximum amount of time to wait between attempts.
 *
 * @returns {number} The number of milliseconds to wait before retrying
 */
export const getRetryMillisecondsWithExponentialBackoff = (
  attempts: number,
  attemptsBeforeExponentialBackoff = DEFAULT_ATTEMPTS_BEFORE_EXPONENTIAL_BACKOFF,
) => {
  if (attempts <= 0) {
    throw new Error('attempts must be greater than 0');
  }

  if (attempts <= attemptsBeforeExponentialBackoff) {
    return INITIAL_RETRY_IN_MS;
  }

  const attemptsWithExponentialBackoff = attempts - attemptsBeforeExponentialBackoff;
  const desiredRetryInMs =
    INITIAL_RETRY_IN_MS * EXPONENTIAL_BACKOFF_FACTOR ** attemptsWithExponentialBackoff;
  return Math.min(MAX_BACKOFF_IN_MS, desiredRetryInMs);
};
